import {z} from 'zod';

import {PaymentTypeSchema} from '@dms/api/shared';
import {CatalogNumberSuggestionSchema, DuplicateDeliveryNoteSchema} from '@dms/api/warehouse';
import i18n from '@dms/i18n';

const catalogNumberSuggestionsSchema = z.array(CatalogNumberSuggestionSchema).nullish();

const basicInformationSchema = z.object({
  supplier: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  warehouse: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  deliveryNoteNumber: z.string().nullish(),
  invoiceNumber: z.string().nullish(),
  authorizationProfile: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  paymentType: PaymentTypeSchema,
  currency: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
  duplicateDeliveryNote: z.array(DuplicateDeliveryNoteSchema).nullish(),
});

const itemSchema = z.object({
  isSelected: z.boolean(),
  pageNumber: z.number(),
  number: z.string().nullish(),
  name: z.string().nullish(),
  manufacturer: z.string().nullish(),
  quantity: z.number().nullish(),
  unit: z.string().nullish(),
  vat: z.string().nullish(),
  unitPrice: z.number().nullish(),
  totalPrice: z.number().nullish(),
  totalPriceWithVat: z.number().nullish(),
  lastAutoFilledCatalogNumber: z.string().nullish(),
});

export type DeliveryNoteItem = z.infer<typeof itemSchema>;

const listOfItemsSchema = z.array(itemSchema);

export const DeliveryNoteDocumentPreviewFormDefinitionSchema = (isConfirmed: boolean) =>
  z.object({
    catalogNumberSuggestions: catalogNumberSuggestionsSchema,
    basicInformation: isConfirmed ? z.record(z.any()) : basicInformationSchema,
    listOfItems: isConfirmed ? listOfItemsSchema : z.array(z.any()),
  });

export type DeliveryNoteDocumentPreviewFormDefinition = z.infer<
  ReturnType<typeof DeliveryNoteDocumentPreviewFormDefinitionSchema>
>;
